export interface BeatInterval {
  timestamp: number;
  duration: number;
}

interface BaseShr {
  timestamp: number;
  pvc: boolean;
}

export interface ValidShr extends BaseShr {
  type: 'valid';
  shr: number;
}

interface InvalidShr extends BaseShr {
  type: 'invalid';
}

export type ShrInterval = ValidShr | InvalidShr;

export const isValidShrInterval = (
  shrInterval: ShrInterval,
): shrInterval is ValidShr => shrInterval.type === 'valid';
